<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 20 20"
>
  <path
    [attr.fill]="color"
    d="M20 2V20H0V2H3V3C3 4.103 3.897 5 5 5C6.103 5 7 4.103 7 3V2H13V3C13 4.103 13.897 5 15 5C16.103 5 17 4.103 17 3V2H20ZM18 8H2V18H18V8ZM16 1C16 0.448 15.553 0 15 0C14.447 0 14 0.448 14 1V3C14 3.552 14.447 4 15 4C15.553 4 16 3.552 16 3V1ZM6 3C6 3.552 5.553 4 5 4C4.447 4 4 3.552 4 3V1C4 0.448 4.447 0 5 0C5.553 0 6 0.448 6 1V3Z"
  />
</svg>
